import { ABCampaigns } from "@/services/ABTestingService/types";

export const PRICING_3_DAY_CAMPAIGN_KEY = "QR-6516: 3 Day Test hidding duration in Pricing Name";
export const PRICING_3_DAY_CAMPAIGN_VARIANT = "3-day-trial";
export const PRICING_3_DAY_CAMPAIGN_ID = "27";

export const PRICING_7_DAY_MOBILE_ONLY_CAMPAIGN_KEY =
  "QR-7009: 7 Day Full Access only plan in mobile";
export const PRICING_7_DAY_MOBILE_ONLY_CAMPAIGN_VARIANT = "7-day-full-access-only-mobile";
export const PRICING_7_DAY_MOBILE_ONLY_CAMPAIGN_ID = "28";

export const AB_CAMPAIGNS: ABCampaigns = {
  TRUSTPILOT_MODULE: { variant: "control", id: "24" },
  [PRICING_7_DAY_MOBILE_ONLY_CAMPAIGN_KEY]: {
    variant: "control", //Default variant
    id: PRICING_7_DAY_MOBILE_ONLY_CAMPAIGN_ID,
  },
  [PRICING_3_DAY_CAMPAIGN_KEY]: {
    variant: "control", //Default variant
    id: PRICING_3_DAY_CAMPAIGN_ID,
  },
};
